import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// const SVGEl = props => (<svg {...props} />)
const StyledSVGEl = styled.svg`
  padding: 0;
  cursor: ${props => (props.onClick ? 'pointer' : 'unset')};

  ${props =>
    props.width &&
    `
    width: ${props.width} !important
  `}

  ${props =>
    props.height &&
    `
    height: ${props.height} !important
  `}
`

const SVG = ({ color, width, height, viewBox, svgPath, onClick, className }) => {
  const widthParam = width ? `${width}px` : undefined
  const heightParam = height ? `${height}px` : undefined
  return (
    <StyledSVGEl
      onClick={onClick}
      className={className}
      width={widthParam}
      height={heightParam}
      viewBox={viewBox}
    >
      <path fill={color} d={svgPath} />
    </StyledSVGEl>
  )
}

SVG.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewBox: PropTypes.string.isRequired,
  svgPath: PropTypes.string.isRequired,
}

export default SVG
